import { LayoutDashboard, Brain } from "lucide-react";
import { AdminShell, AdminForbiddenPage } from "@trillion/auth";
import type { NavItem } from "@trillion/ui/components/app-sidebar";
import { RootLayout } from "../layouts/root-layout";
import { LoginPage } from "../pages/login";
import { DashboardPage } from "../pages/dashboard";
import { IntentsPage } from "../pages/intents";
import { IntentNewPage } from "../pages/intent-new";
import { IntentEditPage } from "../pages/intent-edit";

const navItems: NavItem[] = [
  { label: "Dashboard", href: "/", icon: LayoutDashboard },
  { label: "Intents", href: "/intents", icon: Brain },
];

const logo = (
  <div className="flex size-7 items-center justify-center rounded bg-primary text-primary-foreground">
    <Brain className="size-4" />
  </div>
);

export const routes = [
  {
    element: <RootLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/forbidden", element: <AdminForbiddenPage /> },
      {
        element: <AdminShell appName="Cortex Admin" navItems={navItems} product="cortex" logo={logo} />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "/intents", element: <IntentsPage /> },
          { path: "/intents/new", element: <IntentNewPage /> },
          { path: "/intents/:id", element: <IntentEditPage /> },
        ],
      },
    ],
  },
];
